// src/utils/treeUtils.js
// Immutable tree utilities for nested nodes

// Update node by id (replace node)
export function updateNodeById(treeNode, updatedNode) {
    if (!treeNode) return treeNode;
    if (treeNode.id === updatedNode.id) return updatedNode;
    if (!treeNode.children || treeNode.children.length === 0) return treeNode;
    return {
      ...treeNode,
      children: treeNode.children.map(child => updateNodeById(child, updatedNode))
    };
  }
  
  // Add child under parentId
  export function addChildToParent(tree, parentId, childObj) {
    if (!tree) return tree;
    if (tree.id === parentId) {
      return { ...tree, children: [...(tree.children || []), childObj] };
    }
    return {
      ...tree,
      children: (tree.children || []).map(ch => addChildToParent(ch, parentId, childObj))
    };
  }
  
  // Delete node by id (remove subtree)
  export function deleteNodeById(tree, idToDelete) {
    if (!tree) return null;
    if (tree.id === idToDelete) {
      return null;
    }
    return {
      ...tree,
      children: (tree.children || [])
        .map(ch => deleteNodeById(ch, idToDelete))
        .filter(Boolean)
    };
  }
  
  // Extract node and tree without node
  export function extractNode(tree, nodeId) {
    if (!tree) return { node: null, treeWithoutNode: null };
    if (tree.id === nodeId) return { node: tree, treeWithoutNode: null };
  
    let found = null;
    const newChildren = [];
  
    for (const ch of (tree.children || [])) {
      const { node, treeWithoutNode } = extractNode(ch, nodeId);
      if (node) {
        found = node;
        if (treeWithoutNode) newChildren.push(treeWithoutNode);
        // append others untouched
        // but we don't append the removed node
      } else {
        newChildren.push(ch);
      }
    }
  
    return { node: found, treeWithoutNode: { ...tree, children: newChildren } };
  }
  
  export function moveNode(tree, nodeId, newParentId) {
    const { node, treeWithoutNode } = extractNode(tree, nodeId);
    if (!node) return tree; // not found
    if (newParentId === null || newParentId === undefined) {
      return { ...treeWithoutNode, children: [...(treeWithoutNode.children || []), node] };
    }
    return addChildToParent(treeWithoutNode, newParentId, node);
  }
  
  // Find node by id (returns node or null)
  export function findNodeById(tree, id) {
    if (!tree) return null;
    if (tree.id === id) return tree;
    for (const ch of (tree.children || [])) {
      const res = findNodeById(ch, id);
      if (res) return res;
    }
    return null;
  }
  